/* globals window */
const isDev = process.env.NODE_ENV === 'development'; // HACK: Super simple error logger that expects ga on the window

const SEVERITY = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR'
};

const logException = (message, details, severity = SEVERITY.INFO) => {
  const gtag = window && window.gtag;
  const fullMessage = `[${severity}]: ${message}${details ? `\n[${JSON.stringify(details)}]` : ''}`; // eslint-disable-next-line no-console

  console.info(`[${severity}]`, message, details);
  if (!gtag) return;
  gtag('event', 'exception', {
    description: fullMessage,
    fatal: false
  });
};

module.exports = {
  debug: (message, details) => isDev && logException(message, details, SEVERITY.DEBUG),
  info: (message, details) => isDev && logException(message, details, SEVERITY.INFO),
  warn: (message, details) => isDev && logException(message, details, SEVERITY.WARN),
  error: (message, details) => isDev && logException(message, details, SEVERITY.ERROR)
};